import { Box } from "@mui/material";
import {
  MobileAppInstallBannerCard,
  type MobileAppInstallBannerStores,
} from "Components/MobileApp/MobileAppInstallBanner/MobileAppInstallBannerCard";
import {
  isAndroidBrowser,
  isAndroidTwa,
  isIOSBrowser,
  isNativePlatform,
} from "Utils/Platform/PlatformUtils";

const getVisibleStores = (): MobileAppInstallBannerStores => {
  if (isAndroidBrowser()) {
    return "playStore";
  }

  if (isIOSBrowser()) {
    return "appStore";
  }

  return "both";
};

/**
 * Store-install promo for users browsing outside the installed native apps.
 *
 * Visibility: nothing inside the iOS Capacitor shell or the Android TWA —
 * including the top margin, so hidden means no layout footprint at all;
 * iOS browsers get the App Store badge, Android browsers the Play badge,
 * desktop (and anything else) gets both. iPadOS reporting as "Macintosh"
 * is handled by isIOSBrowser.
 */
export const MobileAppInstallBanner = () => {
  if (isNativePlatform() || isAndroidTwa()) {
    return null;
  }

  return (
    <Box mt={0.5}>
      <MobileAppInstallBannerCard stores={getVisibleStores()} />
    </Box>
  );
};
